export default "__VITE_ASSET__D6z4YQtI__"